import { render } from "./Egresos.vue?vue&type=template&id=97c08dbe&scoped=true"
import script from "./Egresos.vue?vue&type=script&lang=js"
export * from "./Egresos.vue?vue&type=script&lang=js"

import "./Egresos.vue?vue&type=style&index=0&id=97c08dbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97c08dbe"]])

export default __exports__